import React from 'react';
import { RoutePermittedRole } from '@crema/constants/AppEnums';

const StaticsDashboard = React.lazy(() => import('../../modules/statics/Dashboard'));
const OrderAnalysis = React.lazy(() => import('../../modules/statics/OrderAnalysis'));
const MainDashboard = React.lazy(() => import('../../modules/statics/Main'));
const SalesProductAnalysis = React.lazy(() => import('../../modules/statics/SalesProductAnalysis'));
const CartProductAnalysis = React.lazy(() => import('../../modules/statics/CartProductAnalysis'));
const PodProductAnalysis = React.lazy(() => import('../../modules/statics/PodProductAnalysis'));

export const StaticsConfigs = [
  {
    permittedRole: RoutePermittedRole.User,
    path: '/report',
    children: [
      {
        path: 'dashboard',
        element: <StaticsDashboard />,
      },
      {
        path: 'order',
        element: <OrderAnalysis />,
      },
      {
        path: 'channelproduct',
        element: <SalesProductAnalysis />,
      },
      {
        path: 'cart',
        element: <CartProductAnalysis />,
      },
      {
        path: 'approveddesigns',
        element: <PodProductAnalysis />,
      },
    ],
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/main',
    element: <MainDashboard />,
  },
];
